import { apiBasePath } from '../baseUrl';
import { apiUrl } from '../../../utils/api';

const extendedApi = apiBasePath.injectEndpoints({
  endpoints: (build) => ({
    verifyCode: build.mutation({
      query: (data) => ({
        url: `${apiUrl.verifyCode}?DonorId=${data.donorId}&Code=${data.code}`,
        method: 'POST',
      })
    }),
  }),
  overrideExisting: false,
});
export const {
  useVerifyCodeMutation
} = extendedApi;
